import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';

import { Field, reduxForm } from 'redux-form';

import {
  Button,
  Form,
  Grid,
  Row,
  FormGroup,
  Col,
  ControlLabel,
  FormControl,
  FieldGroup,
  Panel,
  Label,
} from 'react-bootstrap';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from '../ViewMessage.css';
import FontAwesome from 'react-icons/fa';

// Helpers
import submit from './submit';
import validate from './validate';

// Component
import Avatar from '../../Avatar';

//Locale
import messages from '../../../locale/messages';

class SendMessage extends Component {
  static propTypes = {
    threadId: PropTypes.number.isRequired,
    profileId: PropTypes.number.isRequired,
    picture: PropTypes.string,
    displayName: PropTypes.string.isRequired,
    formatMessage: PropTypes.func,
  };

  renderFormControlTextArea = ({
    input,
    label,
    meta: { touched, error },
    children,
    className,
    placeholder,
  }) => {
    const { formatMessage } = this.props.intl;
    return (
      <div>
        {touched && error && (
          <span className={s.errorMessage}>{formatMessage(error)}</span>
        )}
        <FormControl
          {...input}
          className={className}
          componentClass="textarea"
          placeholder={placeholder}
        >
          {children}
        </FormControl>
      </div>
    );
  };

  render() {
    const { profileId, picture, displayName } = this.props;
    const { error, handleSubmit, submitting, dispatch } = this.props;
    const { formatMessage } = this.props.intl;

    return (
      <Row className={cx(s.space5)}>
        <Col xs={12} sm={12} md={12} lg={12}>
          <Panel className={cx(s.panelBubble, s.shadowDark, 'messageTextArea')}>
            <form onSubmit={handleSubmit(submit)} height="68px">
              <div className={s.textBody}>
                <Field
                  height="68px"
                  name="content"
                  className={s.textBox + ' p-5'}
                  component={this.renderFormControlTextArea}
                  placeholder={formatMessage(messages.writeMessage)}
                />
              </div>
              <div>
                <div className={s.bottomButton}>
                  <Button
                    className={s.btnPrimary}
                    type="submit"
                    disabled={submitting || error}
                  >
                    <FormattedMessage {...messages.sendMessage} />
                  </Button>
                </div>
              </div>
            </form>
          </Panel>
        </Col>
      </Row>
    );
  }
}

SendMessage = reduxForm({
  form: 'SendMessage', // a unique name for this form
  validate,
})(SendMessage);

export default injectIntl(withStyles(s)(SendMessage));



// WEBPACK FOOTER //
// ./src/components/ViewMessage/SendMessage/SendMessage.js